import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingPaymentActionModel extends Model {
  @attr('boolean') markedAsPaid!: boolean;

  @belongsTo('booking', { inverse: 'bookingPaymentAction', async: false })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-payment-action': BookingPaymentActionModel;
  }
}
